"use client";

import { useState } from "react";
import Image from "next/image";
import type { CharacterPersona } from "./appearance";
import { illustrationUrl, resolveIllustration } from "./illustratedCast";

export default function ProspectPortrait({ persona, className = "", framing = "portrait" }: {
  persona: CharacterPersona;
  className?: string;
  framing?: "portrait" | "figure";
}) {
  const name = persona.name?.trim() || "Prospect";
  const slug = name.toLowerCase().replace(/[^a-z\s-]/g, "").replace(/\s+/g, "-");
  const [failed, setFailed] = useState<string | null>(null);
  const member = resolveIllustration(persona);
  const src = member ? illustrationUrl(member) : `/training/personas/${slug}.webp`;
  return (
    <div role="img" aria-label={name} className={`relative overflow-hidden ${framing === "figure" ? "bg-transparent" : member ? "bg-[#f4efe7]" : "bg-muted"} ${className}`}>
      <span aria-hidden="true" className="absolute inset-0 flex items-center justify-center font-medium text-muted-foreground">
        {name.split(/\s+/).slice(0, 2).map(part => part[0]).join("")}
      </span>
      {failed !== src && <Image src={src} alt="" fill sizes={framing === "figure" ? "(max-width: 640px) 100vw, 680px" : "192px"}
        priority={framing === "figure"} onError={() => setFailed(src)}
        style={member && !member.partner && framing === "portrait" ? { transform: "translateY(4%) scale(1.35)", transformOrigin: "50% 0%" } : undefined}
        className={`absolute inset-0 h-full w-full ${member && (framing === "figure" || member.partner) ? "object-contain" : "object-cover"} ${framing === "portrait" ? "object-top" : "object-center"}`} />}
    </div>
  );
}
